var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2285_13254)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "translate(0.5)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7125 12.3535L9.65469 8.2957C10.2844 7.48164 10.625 6.48633 10.625 5.43945C10.625 4.18633 10.1359 3.01133 9.25156 2.12539C8.36719 1.23945 7.18906 0.751953 5.9375 0.751953C4.68594 0.751953 3.50781 1.24102 2.62344 2.12539C1.7375 3.00977 1.25 4.18633 1.25 5.43945C1.25 6.69102 1.73906 7.86914 2.62344 8.75352C3.50781 9.63945 4.68438 10.127 5.9375 10.127C6.98438 10.127 7.97813 9.78633 8.79219 9.1582L12.85 13.2145C12.8619 13.2264 12.876 13.2358 12.8916 13.2422C12.9071 13.2487 12.9238 13.252 12.9406 13.252C12.9575 13.252 12.9741 13.2487 12.9897 13.2422C13.0052 13.2358 13.0194 13.2264 13.0312 13.2145L13.7125 12.5348C13.7244 12.5229 13.7338 12.5087 13.7403 12.4932C13.7467 12.4776 13.7501 12.461 13.7501 12.4441C13.7501 12.4273 13.7467 12.4106 13.7403 12.3951C13.7338 12.3795 13.7244 12.3654 13.7125 12.3535ZM8.4125 7.91445C7.75 8.57539 6.87187 8.93945 5.9375 8.93945C5.00312 8.93945 4.125 8.57539 3.4625 7.91445C2.80156 7.25195 2.4375 6.37383 2.4375 5.43945C2.4375 4.50508 2.80156 3.62539 3.4625 2.96445C4.125 2.30352 5.00312 1.93945 5.9375 1.93945C6.87187 1.93945 7.75156 2.30195 8.4125 2.96445C9.07344 3.62695 9.4375 4.50508 9.4375 5.43945C9.4375 6.37383 9.07344 7.25352 8.4125 7.91445Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2285_13254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.dc1b1f21b30ab5177bf6aee3eff853de.svg";
export { ForwardRef as ReactComponent };